import { AxiosResponse } from 'axios';
import api from './api';

const uploadImage = async (payload: FormData): Promise<AxiosResponse> => (
  api.post('upload', payload)
);

export default uploadImage;
